import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { IonList, IonItem, IonLabel } from '@ionic/react';
import { AppSelectors } from 'redux/AppRedux';

function LocationDetail({ children, ticket }) {
  const venue = useSelector(AppSelectors.selectVenueDetail);

  if (!venue) return null;

  return (
    <IonList>
      {((ticket && ticket.table) || !venue.isFullPay) && (
        <IonItem slot="start">
          <IonLabel style={{ opacity: 1 }}>
            <div className="d-flex align-center justify-between">
              {ticket && ticket.table && (
                <div className="ion-text-uppercase">
                  <span className="text-bold">Table Number</span>:&nbsp;
                  {ticket.table.name}
                </div>
              )}
            </div>
          </IonLabel>
        </IonItem>
      )}
      {children}
    </IonList>
  );
}

LocationDetail.propTypes = {
  children: PropTypes.node,
  ticket: PropTypes.object,
};

export default LocationDetail;
